import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { User } from 'store/api';

interface userState {
	user: User | null;
	token: string | null;
}

const userString = localStorage.getItem('userData');
const userParsed = userString ? JSON.parse(userString) : null;

const initialState: userState = {
	user: userParsed,
	token: localStorage.getItem('userToken'),
};

export const userSlice = createSlice({
	initialState,
	name: 'userSlice',
	reducers: {
		logout: (state) => {
			localStorage.removeItem('userToken');
			localStorage.removeItem('userData');
			state.token = null;
			state.user = null;
		},
		setUser: (state, action: PayloadAction<User>) => {
			state.user = action.payload;
			localStorage.setItem('userData', JSON.stringify(action.payload));
		},
		setToken: (state, action: PayloadAction<string | null>) => {
			state.token = action.payload;
			if (action.payload) {
				localStorage.setItem('userToken', action.payload);
			} else {
				localStorage.removeItem('userToken');
			}
		},
		updateUser: (state, action: PayloadAction<Partial<User>>) => {
			if (state.user) {
				state.user = { ...state.user, ...action.payload };
			}
		},
	},
});

export const { logout, setUser, updateUser, setToken } = userSlice.actions;
export default userSlice.reducer;
